import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

const ProtectedSuperAdminRoute: React.FC = () => {
    const { user, isLoaded } = useUser();
    
    // Verificar si el usuario es superadmin
    const isSuperAdmin = user?.publicMetadata.role === 'superadmin';
    
    // Mientras carga, se puede mostrar un spinner o nada
    if (!isLoaded) {
        return <div className="flex justify-center items-center h-screen">Cargando...</div>;
    }
    
    // Si no es superadmin, redirigir a la raíz para que RootRedirect resuelva
    // el destino correcto según el rol y el tenantCode del usuario. (Redirigir a
    // "/dashboard" a secas se interpretaba como tenantCode="dashboard" y acababa
    // en "/dashboard/dashboard".)
    if (!isSuperAdmin) {
        return <Navigate to="/" replace />;
    }
    
    // Si es superadmin, renderizar las rutas hijas
    return <Outlet />;
};

export default ProtectedSuperAdminRoute;